import {Skeleton} from '@ds/components';

const HomeSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col gap-4 px-3.5" aria-label="در حال بارگذاری داشبورد">
      {Array.from({length: 3}, (_, index) => (
        <section className="flex flex-col gap-4" key={index}>
          <Skeleton active title={{width: '45%'}} paragraph={{rows: 3}} />
        </section>
      ))}
    </div>
  );
};

export default HomeSkeleton;
